import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { CloseIcon } from "../../../assets/Icons";
import { BtnLoading, formatSize } from "../../utils/operation";
import moment from 'moment';
import ViewModal from './ViewModal';

export const UploadSection = ({
  key,
  FileUploader,
  renderer,
  Progress,
  label,
  assetFileType,
  uploadFile,
  handleChangeUploadFile,
  uploadProgress,
  rendererTagList,
  setVersion,
  version,
  versionsList,
  handleSave,
  error,
  removeFile,
  loading,
  Select,
  handleSelectRendererUsedTag,
  viewFilePreview,
  showAsterisk
}) => {

  const [showVersion, setShowVersion] = useState(false);
  const [fileViewer, setFileViewer] = useState({
    status: false,
    path: null
  });
  
  const closeHistoryModal = () => {
    setShowVersion(false)
  }

  const handleCloseFileViewer = () =>{
      setFileViewer({
        status: false,
        path: null
      });
  }
  const handleOpenFileViewer = (url) =>{
      setFileViewer({
        status: true,
        path: url
      });
  }

  return (
    <>
      <div className="col-lg-6 upload-section-item" key={key}>
        <div className="upload-section-item-header">
        <h5 style={{ fontSize: "1rem" }}>{label} <span>  {showAsterisk && " * "} </span></h5>
        {versionsList.length > 0 && <span onClick={() => setShowVersion(true)}> {label} Version History </span>}
        </div>
        <div className="DragDropMenu uploadfilesss mt-3">
          <div className="fileuploader">
            <FileUploader
              handleChange={(file) =>
                handleChangeUploadFile(file, assetFileType)
              }
              types={[assetFileType]}
              label={
                uploadFile?.name ? "drag & drop or cshoose file to upload" : ""
              }
              name="file"
            >
              <span className="upload-box-info">
                drag & drop or choose Exe file to upload
              </span>
            </FileUploader>
          </div>
        </div>

        {uploadFile && (
          <div className="uploadstatus">
            <div className="upperdiv">
              <div className="uploaddata">
                <div className="xr">
                  <p>{uploadFile?.name}</p>
                  <p
                    onClick={() => removeFile(assetFileType)}
                    style={{ cursor: "pointer", lineHeight: "1" }}
                  >
                    <CloseIcon />
                  </p>
                </div>
                <div className="xr mb-1">
                  <p className="filesize">{formatSize(uploadFile?.size)}</p>
                  <p className="filesize">{uploadProgress}%</p>
                </div>
                <Progress completed={uploadProgress} />
              </div>
            </div>
          </div>
        )}

        <div className="form-group mt-0">
          <p htmlFor="exampleFormControlInput1">
            Renderer<span>*</span>
          </p>
          <Select
            name="RendererUsed"
            className="basic-multi-select mt-2"
            classNamePrefix="select"
            placeholder="Select"
            options={rendererTagList}
            value={renderer}
            onChange={(e) => handleSelectRendererUsedTag(e, assetFileType)}
          />
        </div>

        <div className="form-group mt-0">
          <p className=" flex-row" htmlFor={assetFileType+"_"+key}>
            Version<span>*</span>
          </p>
          <input
            type="text"
            id={assetFileType+"_"+key}
            value={version}
            onChange={(e) => setVersion(e.target.value, assetFileType)}
            className="form-control mt-2"
            placeholder="Enter version"
          />
          <p className="error">{error}</p>
        </div>

        {/* <div>
          <button className="createbtn createbtn-sm" onClick={() => handleSave(assetFileType)} >
            {loading ? <BtnLoading /> : `Save ${label}`}
          </button>
        </div> */}

      </div>

      <Modal show={showVersion} onHide={closeHistoryModal} centered size="xl">
        <Modal.Header className='modalheader'>
          Version History ({label})
          <span onClick={closeHistoryModal} ><CloseIcon /></span>
        </Modal.Header>
        <Modal.Body>
          <div className="current-version">
            <div className="version-table">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">S.No</th>
                    <th scope="col">Date</th>
                    <th scope="col">File Name</th>
                    <th scope="col">Uploaded by</th>
                    <th scope="col">renderer</th>
                    <th scope="col">Version</th>
                    {viewFilePreview && <th scope="col">Action</th>}
                  </tr>
                </thead>

                <tbody>
                  {versionsList && versionsList.map((item,index)=>{
                    let fileName = item.data.assets[0].url.split("/").pop();
                    return(
                        <tr>
                          <td>{index+1}</td>
                          <td>{moment(item.createdAt).format('lll')}</td>
                          <td>{fileName}</td>
                          <td>{item.activities[0].users[0].name}</td>
                          <td>{item.data.renderer}</td>
                          <td>{item.data.version}</td>
                          {viewFilePreview && <td><a onClick={() => {handleOpenFileViewer(item.data.assets[0].url); closeHistoryModal() } }>View</a></td>}
                        </tr>
                    )
                  })}
                </tbody>

              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <ViewModal viewFile={fileViewer.status} filePath={fileViewer.path} handleCloseFileViewer={handleCloseFileViewer} />
    </>
  );
};
export default UploadSection;
